import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IEditorPaneService = ( createDecorator('editorPaneService'));
export { IEditorPaneService };
